export default "__VITE_ASSET__27200c57__"